import * as fromDatatype from '../datatype-library';

export interface bl_fi_item_branch_link_import_file_helper_RowInterface {
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;

    //other fields:
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_validate_error: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_validate_error: fromDatatype.VarcharDatatypeInterface;
    item_branch_link_exist_guid: fromDatatype.GuidDataFieldInterface;
    item_branch_link_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_item_branch_link_import_file_helper_RowClass implements bl_fi_item_branch_link_import_file_helper_RowInterface {
    fi_item_code: fromDatatype.VarcharDatatypeInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;

    //other fields:
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_validate_error: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_validate_error: fromDatatype.VarcharDatatypeInterface;
    item_branch_link_exist_guid: fromDatatype.GuidDataFieldInterface;
    item_branch_link_guid: fromDatatype.GuidDataFieldInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}